import { useEffect, useState } from 'react';
import { studentAPI } from '../services/api';

/**
 * Load a student photo through the authenticated API (JWT on axios).
 * Bare /media/ URLs cannot carry Authorization and must not be used in <img>.
 */
export default function useAuthenticatedStudentPhoto(studentId, enabled, cacheKey = 0) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!enabled || !studentId) {
      setUrl(null);
      return undefined;
    }
    let objectUrl;
    let cancelled = false;
    studentAPI
      .getPhotoObjectUrl(studentId)
      .then((created) => {
        if (cancelled) {
          URL.revokeObjectURL(created);
          return;
        }
        objectUrl = created;
        setUrl(created);
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [studentId, enabled, cacheKey]);

  return url;
}
